import {
  AppWindow,
  ApplicationType,
  SheetWindowApp,
  WindowMetaData,
} from '../types';

// export const isSheetAppWindow = (window?: AppWindow | null): boolean =>
//   !!(window && window.metaData.appType === ApplicationType.Sheet);

export const isSheetAppWindow = (
  window?: AppWindow | null | WindowMetaData
): boolean => {
  if (!window) {
    return false;
  }

  if ('metaData' in window) {
    return window.metaData.appType === ApplicationType.Sheet;
  }

  return window.appType === ApplicationType.Sheet;
};

export const getSheetAppMetaData = (
  window?: AppWindow | null
): SheetWindowApp =>
  isSheetAppWindow(window)
    ? (window?.metaData as SheetWindowApp)
    : {
        sheetId: '',
        groupId: '',
        appType: ApplicationType.Sheet,
      };

      // export const getSheetAppMetaData = (
      //   window?: AppWindow | null | WindowMetaData
      // ): SheetWindowApp => {
      //   const isSheetApp = isSheetAppWindow(window)
      //   if(!isSheetApp) return {
      //     sheetId: '',
      //     groupId: '',
      //     appType: ApplicationType.Sheet,
      //   };


      //   if('metaData' in window) {
      //     return window.metaData as SheetWindowApp
      //   }
      //   if (isSheetAppWindow(window)) {
      //     return window?.metaData as SheetWindowApp;
      //   } else {
      //     return {
      //       sheetId: '',
      //       groupId: '',
      //       appType: ApplicationType.Sheet,
      //     };
      //   }
      // };